module.exports = {
  "zones": {
    "America/Lima": ["z", {
      "wallclock": -1938556800000,
      "format": "-05/-04",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -1938538284000,
      "save": 0,
      "rules": "Peru"
    }, {
      "wallclock": -2524521600000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -18516000,
      "posix": -2524503108000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -18492000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Peru": [{
      "from": 1994,
      "to": 1994,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1994,
      "to": 1994,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 1990,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1990,
      "to": 1990,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1987,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1986,
      "to": 1987,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1939,
      "to": 1940,
      "month": 2,
      "day": [0, 24],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1938,
      "to": 1939,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1938,
      "to": 1938,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1938,
      "to": 1938,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};